import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  useMediaQuery,
  Theme,
} from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Schema } from 'yup';

import useStyles from './styles';
import { ItemForm, FormReset, FormSubmit } from '..';
import { TimesIcon } from '../icon/solid';
import { useId } from '../../hooks';

type Props = {
  open: boolean;
  // className?: string;
  paperClassName?: string,
  form?: {
    data: any;
    validationSchema: Schema<unknown>;
    onSubmit: (values: any) => void;
    creatingMode?: boolean;
    submitTitle?: React.ReactNode;
    loading?: boolean;
    formStyles?: string;
  };
  title: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  onCloseHandler?: () => void;
  keyHandler?: (e: React.KeyboardEvent) => void;
  closeOnCancel?: boolean;
  hideCancel?: boolean;
};

const Modal = ({
  paperClassName = '',
  // className,
  open,
  form,
  title,
  children,
  actions,
  onCloseHandler = () => {},
  closeOnCancel = true,
  hideCancel = false,
}: Props) => {
  const id = useId();
  const classes = useStyles();
  const theme = useTheme<Theme>();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [openState, setOpenState] = useState(open);

  const closeHandler = useCallback(() => {
    setOpenState(false);
    onCloseHandler();
  }, [setOpenState, onCloseHandler]);

  useEffect(() => setOpenState(open), [open, setOpenState]);

  return (
    <Dialog
      open={openState}
      aria-labelledby={id}
      disableBackdropClick
      PaperProps={{ className: `${classes.modal} ${paperClassName}` }}
      fullWidth
      fullScreen={fullScreen}
      style={{ zIndex: 2147483100 }}
      onClose={onCloseHandler}
      // className={className}
    >
      <DialogTitle id={id}>
        {title}
        <IconButton aria-label="close" className={classes.closeButton} onClick={closeHandler}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>


      {form && (
        <ItemForm
          hideActions
          loading={false}
          initialValues={form.data}
          validationSchema={form.validationSchema}
          onSubmit={form.onSubmit}
          // enableReinitialize
          validateOnMount
          validateOnChange
          formStyles={form.formStyles}
        >
          <DialogContent className={classes.dialogContent}>{children}</DialogContent>
          <DialogActions className={clsx(classes.dialogActions, {
            [classes.singleAction]: hideCancel,
          })}
          >
            {!hideCancel
            && (
              <FormReset
                className={clsx(classes.cancelButton, classes.panelButton)}
                variant="contained"
                color="default"
                withHotkey
                closeDialog={onCloseHandler}
                closeOnCancel={closeOnCancel}
              >

                <TimesIcon className={classes.buttonIcon} />
                <span className={classes.buttonText}>Cancel</span>
              </FormReset>
            )}
            <FormSubmit
              className={classes.panelButton}
              variant="contained"
              color="primary"
              withHotkey
              disabled={form?.loading}
            >
              <span className={classes.buttonText}>
                {form.submitTitle ? form.submitTitle : (form.creatingMode ? 'Create' : 'Save')}
              </span>
            </FormSubmit>
          </DialogActions>
        </ItemForm>
      )}

      {!form && (
        <>
          <DialogContent>{children}</DialogContent>
          {actions && (
            <DialogActions className={classes.dialogActions}>
              {actions}
            </DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};

export default Modal;
